import React from 'react';
import { Box, Card, CardMedia, Link as MuiLink, Paper, Typography } from '@mui/material';

/**
 * Custom Banner Ad Component
 * Displays custom image/HTML ads as fallback or primary ad source
 * 
 * @param {string} imageUrl - URL to ad image
 * @param {string} link - Destination URL when ad is clicked
 * @param {string} alt - Alt text for image
 * @param {object} style - Custom styles
 */
const CustomBanner = ({ 
  imageUrl, 
  link, 
  alt = 'Advertisement',
  style = {},
  ...props 
}) => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  if (!imageUrl) {
    if (isDevelopment) {
      return (
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 90,
            bgcolor: 'grey.100',
            border: '2px dashed',
            borderColor: 'grey.300',
            borderRadius: 1,
            ...style,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Custom Ad Space
          </Typography>
        </Paper>
      );
    }
    return null; // Production - show nothing
  }

  const adContent = (
    <CardMedia
      component="img"
      image={imageUrl}
      alt={alt}
      sx={{
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        cursor: link ? 'pointer' : 'default',
      }}
    />
  );

  return (
    <Box
      className="custom-ad-container"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        overflow: 'hidden',
        ...style,
      }}
      {...props}
    >
      <Card elevation={0} sx={{ width: '100%', bgcolor: 'transparent' }}>
        {link ? (
          <MuiLink
            href={link}
            target="_blank"
            rel="noopener noreferrer sponsored"
            sx={{ display: 'block', textDecoration: 'none' }}
          >
            {adContent}
          </MuiLink>
        ) : (
          adContent
        )}
      </Card>
    </Box>
  );
};

export default CustomBanner;
